import * as _ from "lodash";

export default class HistoryStack<T> {
    private readonly _capacity: number;
    private _list: T[];
    private _position: number;

    constructor(capacity: number = 10) {
        this._capacity = capacity;
        this._list = [];
        this._position = 0;
    }

    public get isEmpty() {
        return this.count === 0;
    }

    public get count() {
        return this._list.length;
    }

    public push(...items: T[]): void {
        if (this._position > 0) {
            this.truncate();
        }
        items.forEach(item => {
            this._list.unshift(item);
            if (this.count > this._capacity) {
                this._list.pop();
            }
        })


    }

    public pop(): T {
        return this._list.shift();
    }

    public peek(): T {
        if (this.count > 0) {
            return this._list[0];
        }
        return null;
    }

    public clear() {
        this._list = [];
    }

    public remove(predicate: (item: T) => boolean) {
        _.remove(this._list, predicate);
        this._position = 0;
    }

    private truncate() {
        if (this._position > 0) {
            this._list.splice(0, this._position);
            this._position = 0;
        }
    }

    public get current(): T {
        return this._list[this._position];
    }

    /**
     * Forward in time means closer to index 0;
     */
    public forward() {
        if (this.count === 0) {
            throw new Error("Can't move forward in an empty history.");
        }
        if (this._position === 0) {
            throw new Error("Reached the end of history.");
        } else {
            this._position--;
            return this._list[this._position];
        }
    }

    public backward() {
        if (this.count === 0) {
            throw new Error("Can't move backward in an empty history.");
        }
        if (this._position === this._list.length - 1) {
            throw new Error("Reached the end of history.");
        } else {
            this._position++;
            return this._list[this._position];
        }
    }

    public getAll() {
        return this._list;
    }

    public get canMoveBackward() {
        return this.count > 0 && this._position < this._list.length - 1;
    }

    public get canMoveForward() {
        return this.count > 0 && this._position > 0;
    }
}
